import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

@Component({
  selector: 'app-stock-checking-approval',
  templateUrl: './stock-checking-approval.component.html',
  styleUrls: ['./stock-checking-approval.component.scss']
})
export class StockCheckingApprovalComponent implements OnInit {

  salesList: any[] = [];
  selectedSales: any[] = [];

  constructor(private http: HttpClient, public AppService: AppService) { }

  ngOnInit(): void {
    this.loadData();
  }
selectall(){
    const allSelected = this.salesList.every(sale => sale.selected);
  this.salesList.forEach(sale => sale.selected = !allSelected);
  this.selectedSales = this.salesList.filter(sale => sale.selected);
  }
  
  loadData() {
    this.AppService.get('api/transaction/GetStockcheck').subscribe({
      next: (res: any) => {
        const data = typeof res === 'string' ? JSON.parse(res) : res;

        if (data && Array.isArray(data.record)) {
          this.salesList = data.record.map(r => ({
            stockid: r.SA_iid,
            PurchaseId: r.SA_Item_id,
            Barcode: r.SA_ItemBarcode,
            Itemname: r.SA_ItemName,
            Employeename: r.SA_Employeename,
            Actual_Qty: r.SA_ActualQty,
            Instock: r.SA_InStock,
            SA_storeid: r.SA_storeid,
            selected: false
          }));
        } else {
          this.salesList = [];
        }

        this.selectedSales = [];
        //console.log('Loaded salesList:', this.salesList);
      },
      error: (err) => alert('Failed to load data: ' + err.message)
    });
  }

 
  toggleSelection(sale: any) {
    sale.selected = sale;
    this.selectedSales = this.salesList.filter(s => s.selected);
    console.log('Selected sales:', this.selectedSales);
  }

  
  approveSelected() {
    if (this.selectedSales.length === 0) {
      alert('Please select at least one record.');
      return;
    }

    if (!confirm('Are you sure you want to approve the selected record(s)?')) return;

    const approvedBy = this.AppService.username || localStorage.getItem('username') || 'admin';
    let successCount = 0;

    of(...this.selectedSales)
      .pipe(
        concatMap(sale => {
          const payload = {
            Barcode: sale.Barcode,
            username: approvedBy,
            stockid: sale.stockid,
            PurchaseId: sale.PurchaseId,
            Actual_Qty: sale.Actual_Qty,
            Instock: sale.Instock,
            SA_storeid: sale.SA_storeid
          };
          console.log('Approving:', payload);
          return this.AppService.postTable('api/transaction/Adjuststock', payload);
        })
      )
      .subscribe({
        next: (res) => {
          console.log('Response:', res);
          successCount++;
        },
        complete: () => {
          alert(`${successCount} record(s) approved successfully!`);
          
          const approvedIds = this.selectedSales.map(s => s.stockid);
          this.salesList = this.salesList.filter(s => !approvedIds.includes(s.stockid));
          this.selectedSales = [];
        },
        error: (err) => alert('Error approving record(s): ' + err.message)
      });
  }
sales() {
  console.log("The length is " + this.selectedSales.length);

  if (this.selectedSales.length === 0) {
    alert('Please select at least one record.');
    return;
  }
  

  let successCount = 0;

  for (let i = 0; i < this.selectedSales.length; i++) {
    const sale = this.selectedSales[i];

    const payload = {
      Barcode: sale.Barcode,
      username: this.AppService.username || localStorage.getItem('username') || 'admin',
      stockid: sale.stockid,
      PurchaseId: sale.PurchaseId,
      Actual_Qty: sale.Actual_Qty,
      Instock: sale.Instock,
      SA_storeid: sale.SA_storeid
    };

    console.log('Approving:', payload);

    this.AppService.postTable('api/transaction/Adjuststock', payload).subscribe({
      next: (res) => {
        console.log('Response:', res);

        if (res === 'True' || res === true) {
          successCount++;
        }
      },
      error: (err) => {
        console.error('Error approving:', err);
      },
      complete: () => {
    
        if (i === this.selectedSales.length - 1) {
          alert(`${successCount} record(s) approved successfully!`);

  
          const approvedIds = this.selectedSales.map(s => s.stockid);
          this.salesList = this.salesList.filter(s => !approvedIds.includes(s.stockid));
          this.selectedSales = [];
        }
      }
    });
  }
}

  // sales(){
  //   console.log("the length is "+this.selectedSales.length);
  //   for(let i=0;i<this.selectedSales.length;i++){
  //     //this.selectedSales.push(this.salesList[i]);
  //     const sale = this.selectedSales[i];

  //   const payload = {
  //     Barcode: sale.Barcode,
  //     username: this.AppService.username || localStorage.getItem('username') || 'admin',
  //     stockid: sale.stockid,
  //     PurchaseId: sale.PurchaseId,
  //     Actual_Qty: sale.Actual_Qty,
  //     Instock: sale.Instock,
  //     SA_storeid: sale.SA_storeid
  //   };

  //     console.log('Approving:', payload); 
  //     this.AppService.postTable('api/transaction/Adjuststock', payload).subscribe({
  //       next: (res) => {
  //       }});
  //   }
  // }

  rejectSelected() {
    if (this.selectedSales.length === 0) {
      alert('Please select at least one record.');
      return;
    }

    if (!confirm('Are you sure you want to reject the selected record(s)?')) return;

    of(...this.selectedSales)
      .pipe(
        concatMap(sale =>
          this.AppService.getTable(`api/transaction/RejectStockcheck?id=${sale.stockid}`)
        )
      )
      .subscribe({
        complete: () => {
          alert('All selected records rejected successfully!');
          const rejectedIds = this.selectedSales.map(s => s.stockid);
          this.salesList = this.salesList.filter(s => !rejectedIds.includes(s.stockid));
          this.selectedSales = [];
        },
        error: (err) => alert('Error rejecting record(s): ' + err.message)
      });
  }
}
